import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SitemarkIcon() {
  return (
    <SvgIcon sx={{ height: 21, width: 100, mr: 2, color: "text.primary" }}>
      <svg
        width="100"
        height="21"
        viewBox="0 0 100 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <text
          x="0"
          y="16"
          fontFamily="Inter, sans-serif"
          fontSize="14"
          fontWeight="600"
          fill="currentColor"
        >
          Savac Plus
        </text>
      </svg>
    </SvgIcon>
  );
}
